var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretRegularDown = function SvgCaretRegularDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.26 12.195c.409.407 1.07.407 1.474 0l6.96-6.923a1.03 1.03 0 0 0 0-1.467 1.047 1.047 0 0 0-1.475 0l-6.22 6.188-6.22-6.188a1.043 1.043 0 0 0-1.474 0 1.034 1.034 0 0 0 0 1.467l6.96 6.923z"
  })));
};
export default SvgCaretRegularDown;